import styled, { css } from 'styled-components';

export const DropDownItemWithIcon = styled.span`
  display: flex;
  align-items: center;

  > svg {
    margin-right: 8px;
  }
`;

export const SideBarButton = styled.button`
  --transition-duration: 300ms;
  --size: 40px;

  height: var(--size);
  width: var(--size);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: none;
  border-radius: 6px;
  transition: background var(--transition-duration),
    color var(--transition-duration);
  color: ${(p) =>
    p.active
      ? 'var(--color-interface-neutral-light)'
      : 'var(--color-interface-secondary-normal)'};
  background: ${(p) =>
    p.active ? 'var(--color-interface-secondary-normal)' : 'none'};

  &:focus,
  &:hover {
    background: var(--color-interface-secondary-lighter);
    color: var(--color-interface-neutral-light);
  }

  &:active {
    background: var(--color-interface-secondary-darker);
  }

  ${(p) =>
    p.$disabled &&
    css`
      color: var(--color-interface-content-lightest);
      background: none;
      cursor: default;

      &:focus {
        color: var(--color-interface-content-lightest);
        background: none;
      }

      &:hover {
        color: var(--color-interface-content-lighter);
        background: none;
      }
    `}
`;
